export const IMAGE_STYLE = {
  PHOTOGRAPHIC: 'PHOTOGRAPHIC',
  VECTOR_IMAGE: 'VECTOR_IMAGE',
  ILLUSTRATION: 'ILLUSTRATION',
  '3D': '3D',
} as const
export type ImageStyle = (typeof IMAGE_STYLE)[keyof typeof IMAGE_STYLE]

export const convertImageStyleForAutomation = (imageStyle: ImageStyle) => {
  return (
    {
      [IMAGE_STYLE.PHOTOGRAPHIC]: 'photo',
      [IMAGE_STYLE.VECTOR_IMAGE]: 'vector',
      [IMAGE_STYLE.ILLUSTRATION]: 'illustration',
      [IMAGE_STYLE['3D']]: '3d',
    } as const
  )[imageStyle]
}

export const IMAGE_SIZE = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
  SQUARE: 'SQUARE',
} as const
export type ImageSize = (typeof IMAGE_SIZE)[keyof typeof IMAGE_SIZE]

export const convertImageSizeForAutomation = (imageSize: ImageSize) => {
  return (
    {
      [IMAGE_SIZE.LANDSCAPE]: 'landscape',
      [IMAGE_SIZE.PORTRAIT]: 'portrait',
      [IMAGE_SIZE.SQUARE]: 'square',
    } as const
  )[imageSize]
}

export const AI_IMAGE_GENERATOR_GENERATE_STATE = {
  PENDING: 'PENDING',
  DOWNLOADED: 'DOWNLOADED',
  PROJECT_CREATING: 'PROJECT_CREATING',
  PROJECT_CREATED: 'PROJECT_CREATED',
  ERROR: 'ERROR',
} as const

export type AiImageGeneratorGenerateState =
  keyof typeof AI_IMAGE_GENERATOR_GENERATE_STATE

export const MAX_FREE_TRIAL_COUNT = 1
